import { put, select, takeLatest } from 'redux-saga/effects'
import { SpecialReportsConstants } from '../store/specialReports.constants'
import { getSpecialReportsSelector } from '../selectors'
import { getCrewListSelector } from '../../crew/selectors'
import { setAuthor, setCrew, setBase, setUnit } from '../store/specialReports.actions'
import { ISpecialReportsState } from '../store/specialReports.types'
import { ICrewMemberList } from '../../crew/store/crew.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOption, IOptions } from '../../../common/common.types'
import { getTripInformationSelector } from '../../tripInformation/selectors'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'

export function* initializeSpecialReport() {
  try {
    const specialReportsState: ISpecialReportsState = yield select(getSpecialReportsSelector)
    const crewList: ICrewMemberList = yield select(getCrewListSelector)
    const tripInformation: ITripInformationState = yield select(getTripInformationSelector)
    const { base, unit } = tripInformation

    if (!specialReportsState.author && crewList.length > 0) {
      yield put(setAuthor(crewList[0].userId))
    }

    if (!specialReportsState.base && crewList.length > 0 && base) {
      yield put(setBase({ id: base.id, name: base.name }))
    }

    if (!specialReportsState.unit && crewList.length > 0 && unit) {
      yield put(setUnit({ id: unit.id, name: unit.name }))
    }

    if (specialReportsState.crew.length === 0) {
      if (crewList.length > 0) {
        const availableCrewMembers: IOption[] = crewList
          .map((crewMember) => crewMember.userId)
          .filter((userId): userId is IOption => userId !== null)

        const initializedCrew: IOptions = availableCrewMembers.map((crewMember, index) => ({
          id: crewMember.id,
          name: crewMember.name || '',
          seq: index,
        }))

        yield put(setCrew(initializedCrew))
      } else {
        yield put(setCrew([]))
      }
    }
  } catch (e) {
    yield put(throwPcrException(`initializeSpecialReport() error: ${e}`))
  }
}

export function* initializeSpecialReportSaga() {
  yield takeLatest([SpecialReportsConstants.INITIALIZE_SPECIAL_REPORT], initializeSpecialReport)
}
